export default __webpack_public_path__ + "static/media/disc-bottom-fork-guards.43fd1349.glb";